import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const selectedSearchValues = this.props.selectedSearchValues;
        const interEstateLeafReport = this.props.interEstateLeafReport;
        const contentRowNames = this.props.contentRowNames;
        const totalGross = this.props.totalGross;
        const totalDeduction = this.props.totalDeduction;
        const totalNet = this.props.totalNet;

        return (
            <div>
                <h3><center><u>Inter Estate Leaf Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {selectedSearchValues.group}</div>
                    <div className="col"><b>Factory: </b> {selectedSearchValues.operationEntity}</div>
                    <div className="col"><b>Date: </b> {selectedSearchValues.date}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow style={{ border: "2px solid black" }} >
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Inter Estate</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Inter Estate Division</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Deduction (Kg)</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Net (Kg)</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {interEstateLeafReport.map((row) => {                                                    
                                    return (
                                            <>
                                            {row.map((column) => (
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="left"> {column.interEstate}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="left"> {column.interEstateDivision}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center">{parseFloat(column.gross).toFixed(2)}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(column.deduction).toFixed(2)}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(column.net).toFixed(2)}</TableCell>
                                                </TableRow>))}
                                                
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell colSpan={2} style={{ border: "2px solid black" }} component="th" scope="row" align="left">Total</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center">{parseFloat(row.totalGross).toFixed(2)}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(row.totalDeduction).toFixed(2)}</TableCell>
                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(row.totalNet).toFixed(2)}</TableCell>
                                                </TableRow>
                                            </>);
                                        })}
                                        <TableRow style={{ border: "2px solid black" }}>
                                            <TableCell colSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }} align="left">Grand Total</TableCell>
                                            <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                {interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalGross), 0).toFixed(2)}
                                            </TableCell>
                                            <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                {interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalDeduction), 0).toFixed(2)}
                                            </TableCell>
                                            <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                {interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalNet), 0).toFixed(2)}
                                            </TableCell>
                                        </TableRow>                                                     
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
}
